import { useMerchant } from '@domain/merchants/queries/useMerchant';
import { useOrder } from '@olo-web/domain/orders/queries/useOrder';
import { EOrderTypes } from '@olo-web/types/enums';

export const useIsPickup = () => {
  const { data: order } = useOrder();
  const { data: merchant } = useMerchant();
  return order?.orderTypeId === merchant?.orderTypeIds[EOrderTypes.PICKUP];
};
